(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page--brands"]) return;
  try {
    
  document.getElementById('search').addEventListener('keyup', function () {
    var $query = document.getElementById('search');
    var $catalog = document.getElementById('catalog');
    var $vendors = document.querySelectorAll('.catalog-item-vendor');
    var $results = document.querySelectorAll('.catalog-item-vendor[data-name*="' + $query.value.toLowerCase() + '"]');

    if ($query.value) {
      $catalog.classList.add('search-results');

      for (var $vendor of $vendors) $vendor.classList.remove('search-vendor');
      for (var $result of $results) $result.classList.add('search-vendor');
    } else {
      $catalog.classList.remove('search-results');

      for (var $vendor of $vendors) $vendor.classList.remove('search-vendor');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
